module.exports = __webpack_public_path__ + "_/markerclustererplus/images/m4.png";